//Generated File 
export default class ApplicationVersion{
	static readonly BUILD_DAY = 5;
	static readonly BUILD_HOUR = 20;
	static readonly BUILD_MINUTE = 36;
	static readonly BUILD_MONTH = 10;
	static readonly BUILD_YEAR = 2026;
	static readonly DATABASE_VERSION = 156;
	static readonly SERVER_VERSION = 7;
}
